import styles from './contactInformation.module.css';
import stylesSide from './sidemenu.module.css';
import { getBackgroundColor } from '../../../code/ColorHandler';
import { useLocation } from "react-router-dom";
import { Icons } from '../../../code/IconHandler';
function ContactInformantion({ isContactOpen, setIsContactOpen }) {
    const location = useLocation();
    return (
        <>
            {isContactOpen && <div className={stylesSide.menuOverlay} onClick={() => setIsContactOpen(false)}></div>}
            <div className={`${styles.contactInformation} ${isContactOpen ? styles.open : ""}`} style={{ background: getBackgroundColor(location) }}>
                <Icons.X className={styles.x} onClick={() => setIsContactOpen(false)} />
                <div className={styles.head}>
                    <h2>Kontakt</h2>
                </div>
                <div className={styles.body}>
                    <section>
                        <h3>Geschäftsstelle</h3>
                        <div className={styles.sectionDiv}>
                            <div className={`${styles.vertical} ${styles.adress}`}>
                                <p>TuS 05 Oberpleis</p>
                                <p>Humboldtstraße 3a</p>
                                <p>53639 Königswinter</p>
                            </div>
                            <div className={styles.vertical}>
                                <div className={styles.horizontal}>
                                    <Icons.Phone
                                        className={styles.icon}
                                    />
                                    <p>02244 / 90 20 117</p>
                                </div>
                                <div className={styles.horizontal}>
                                    <Icons.Mail
                                        className={styles.icon}
                                    />
                                    <a href='mailto:geschaeftsstelle@tus05-oberpleis.de'>geschaeftsstelle@tus05-oberpleis.de</a>
                                </div>
                            </div>
                            <div className={styles.vertical}>
                                <p><strong>Öffnungszeiten:</strong></p>
                                <div className={styles.horizontal}>
                                    <span className={styles.day}>Mo - Do:</span>
                                    <span className={styles.time}>09:00 - 17:00 Uhr</span>
                                </div>
                                <div className={styles.horizontal}>
                                    <span className={styles.day}>Fr:</span>
                                    <span className={styles.time}>09:00 - 14:00 Uhr</span>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <h3>Ansprechpartner:innen</h3>
                        <ul>
                            <li><a href='/mannschaftssport/badminton#ansprechpartner'
                                onClick={() => setIsContactOpen(false)}
                            >Badminton</a></li>
                            <li><a href='/mannschaftssport/basketball#ansprechpartner'
                                onClick={() => setIsContactOpen(false)}
                            >Basketball</a></li>
                            <li><a href='/mannschaftssport/fußball#ansprechpartner'
                                onClick={() => setIsContactOpen(false)}
                            >Fußball</a></li>
                            <li><a href='/unser-verein/tus-05-organisation#ansprechpartner'
                                onClick={() => setIsContactOpen(false)}
                            >Mitgliederverwaltung</a></li>
                            <li><a href='/unser-verein/tus-05-organisation#ansprechpartner'
                                onClick={() => setIsContactOpen(false)}
                            >Reha-Sport</a></li>
                        </ul>
                    </section>
                </div>
            </div>
        </>

    )
}
export default ContactInformantion;